
/*
 jSignature uses FlashCanvas ONLY for old browser support (aka IE8 and below).
 */
window.FlashCanvasOptions = {
	/*
	 Tell flashcanvas.js where to find it's swf file. Note that the default behaviour
	 is to search for the swf in the same directory from which flashcanvas.js was
	 loaded from. When cramming is turned off (default for dev) this isn't needed
	 because both files will be served from the same directory. It should also be
	 noted that cramming needs to be turned on in order to support IE8 due to
	 limitations on the number of external js and css files. 
	 */
	swfPath: '/media/js/surveys/'
};